import { Toast } from "primereact/toast"
import { createContext, RefObject } from "react"

interface GlobalToast {
  ref: RefObject<Toast> | undefined;
}

const globalToastContext = createContext<GlobalToast>({
  ref: undefined,
})

export default globalToastContext
